/**
 * External Dependencies
 */
import 'jquery';
import '@fancyapps/fancybox';
import { Loader } from '@googlemaps/js-api-loader';
// import { Marker } from '@googlemaps/adv-markers-utils';
import axios from 'axios/dist/axios';

$(document).ready(() => {
  const restRoot = window.xhrObj.root;
  const pageId = window.xhrObj.pageId;
  let currentInfoWindow = null;

  axios.get(`${restRoot}wp/v2/pages/${pageId}`)
    .then(res => {
      const mapBlockAcfFields = res.data.block_data.filter(block => block.blockName === 'acf/map-section-1')[0].attrs.data;
      const placesLength = mapBlockAcfFields.places ?? 0;
      let placesArray = [];

      if ( placesLength > 0 ) {
        for (let i = 0; i < placesLength; i++) {
          placesArray.push({
            lat: mapBlockAcfFields[`places_${i}_lat`],
            lng: mapBlockAcfFields[`places_${i}_lng`],
            pin: mapBlockAcfFields[`places_${i}_pin`] ?? 'default',
            title: mapBlockAcfFields[`places_${i}_title`],
            text: mapBlockAcfFields[`places_${i}_text`],
            button: mapBlockAcfFields[`places_${i}_button`],
          });
        }
      }

      const mapObject = {
        api: mapBlockAcfFields.api_key,
        mapID: mapBlockAcfFields.map_id,
        zoom: mapBlockAcfFields.map_zoom ?? 5,
        places: placesArray,
      };

      return mapObject;
    })
    .then(mapObject => {
      const loader = new Loader({
        apiKey: mapObject.api,
        // version: "weekly",
        libraries: ["marker"],
      });

      let mapOptions = {
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        mapId: mapObject.mapID,
      };

      const loadMap = (lat, lng, status, uState) => {
        mapOptions.center = { lat: lat, lng: lng };
        mapOptions.zoom = status === 'geolocated' ? Number(mapObject.zoom) : 5;

        loader
          .load()
          .then((google) => {
            const map = new google.maps.Map(document.getElementById('g-map'), mapOptions);
            const AdvancedMarkerElement = google.maps.marker.AdvancedMarkerElement;
            let statesIncluded = false;

            if (mapObject.places.length > 0) {
              mapObject.places.forEach((place) => {
                const glyphImg = document.createElement('img');

                if ( place.pin === 'outlined' ) {
                  glyphImg.src = '/wp-content/themes/galaxy-vets/resources/assets/images/icons/map-marker-2.svg';
                } else {
                  glyphImg.src = '/wp-content/themes/galaxy-vets/resources/assets/images/icons/map-marker.svg';
                }

                const marker = new AdvancedMarkerElement({
                  position: { lat: Number(place.lat), lng: Number(place.lng) },
                  map,
                  title: place.title,
                  content: glyphImg,
                });

                let infoWindowContent = `
                <div class="map-info-window">
                  <h3 class="h6">${place.title}</h3>
                  <p>${place.text}</p>
                `;

                if (place.button.url) {
                  infoWindowContent += `<div class="text-center"><a href="${place.button.url}" data-fancybox class="btn btn--white2 btn--arrow btn--sm" id=""><span class="inline-block align-middle relative z-10">${place.button.title}</span><div class="bg"></div></a></div>`;
                }

                infoWindowContent += `</div>`;

                let infoWindow = new google.maps.InfoWindow({
                  content: infoWindowContent,
                });

                marker.addListener('click', () => {
                  if (currentInfoWindow) {
                    currentInfoWindow.close();
                  }

                  infoWindow.open(map, marker);
                  currentInfoWindow = infoWindow;

                  let geocoder = new google.maps.Geocoder();
                  let latlng = { lat: Number(place.lat), lng: Number(place.lng) };

                  geocoder.geocode({ location: latlng }, (results, status) => {
                    if (status === 'OK') {
                      if (results[0]) {
                        const addressComponents = results[0].address_components;
                        const country = addressComponents.find(component => component.types.includes('country')) ? addressComponents.filter(component => component.types.includes('country'))[0].long_name : '';
                        const city = addressComponents.find(component => component.types.includes('locality')) ? addressComponents.filter(component => component.types.includes('locality'))[0].long_name : '';
                        const state = addressComponents.find(component => component.types.includes('administrative_area_level_1')) ? addressComponents.filter(component => component.types.includes('administrative_area_level_1'))[0].long_name : '';

                        console.log(country, city, state);

                        $('#map-popup input[name="country"]').val(country);
                        $('#map-popup input[name="city"]').val(city);
                        $('#map-popup input[name="state"]').val(state);
                      }
                    }
                  });
                });

                // // get array of states markers
                let geocoder2 = new google.maps.Geocoder();
                let latlng2 = { lat: Number(place.lat), lng: Number(place.lng) };

                geocoder2.geocode({ location: latlng2 }, (results, status) => {
                  if (status === 'OK') {
                    if (results[0]) {
                      const addressComponents2 = results[0].address_components;
                      const state2 = addressComponents2.find(component => component.types.includes('administrative_area_level_1')) ? addressComponents2.filter(component => component.types.includes('administrative_area_level_1'))[0].short_name : '';

                      if ( state2 == uState ) {
                        const stateCenterLat = results[0].geometry.location.lat();
                        const stateCenterLng = results[0].geometry.location.lng();

                        map.setCenter({ lat: stateCenterLat, lng: stateCenterLng });
                        map.setZoom(Number(mapObject.zoom));
                        statesIncluded = true;
                      }
                    }
                  }
                });
              });

              if ( !statesIncluded ) {
                map.setZoom(5);
              }
            }
          })
          .catch(e => {
            console.log(e);
          });
      };

      axios.get('https://ipapi.co/json/').then((res) => {
        // const uLat = res.data.latitude;
        // const uLng = res.data.longitude;
        const uState = res.data.region_code;
        // console.log(res.data);

        loadMap(37.0902, -95.7129, 'geolocated', uState);
      }).catch((err) => {
        console.log(err);
        loadMap(37.0902, -95.7129, 'default');
      });
    });


  console.log('Map JS loaded');
});
